






































import Vue from "vue"
import { vueWith } from "./../vueWith"

export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: {
    // initValue: String,
  },
  data() {
    return {
      //
    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    //
  },

  methods: {

    // 子から呼ばれる ---------------------------------------------

  },
})


